import { isSignInWithEmail } from '@/modules/auth/index-firebase'

const TIME_AT_ZERO_TABS_KEY = 'EHR_TIME_AT_ZERO_TABS'
const EHR_TAB_COUNT_KEY = 'EHR_TABS'
export const ADD_TAB = 'ADD_TAB'

function getTimeAtZeroTabs() {
  return Number(localStorage.getItem(TIME_AT_ZERO_TABS_KEY))
}

export function setTimeAtZeroTabs() {
  localStorage.setItem(TIME_AT_ZERO_TABS_KEY, new Date().getTime())
}

export function clearTimeAtZeroTabs() {
  localStorage.removeItem(TIME_AT_ZERO_TABS_KEY)
}

function getOpenTabs() {
  return Number(localStorage.getItem(EHR_TAB_COUNT_KEY))
}

export function hasZeroOpenTabs() {
  return getOpenTabs() === 0
}

export function updateTabCount(operation) {
  const isAdd = operation === ADD_TAB
  let tabCounter
  if (isAdd) {
    clearTimeAtZeroTabs()
    tabCounter = getOpenTabs() + 1
  } else {
    tabCounter = getOpenTabs() - 1
  }
  localStorage.setItem(EHR_TAB_COUNT_KEY, tabCounter)
}

function isReload() {
  const navEntries = performance.getEntriesByType('navigation')
  return navEntries.some(entry => entry.type === 'reload')
}

export function shouldAutoLogout() {
  if (isSignInWithEmail()) return false
  return hasZeroOpenTabs() && getTimeAtZeroTabs() && !isReload()
}
